export default __webpack_public_path__ + "static/media/boutton.1a206c03.png";